/**
 * PublicLayout — Layout for public pages (login, errors)
 *
 * Used for:
 * - /login
 * - /AccessDenied
 * - Any page that doesn't need AppShell
 *
 * Does NOT apply guards (allows unauthenticated users)
 */

import React, { ReactNode, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from '@src/apps/Footer/Footer';
import { RouteConfig } from '../types';
import styles from './PublicLayout.module.css';

interface PublicLayoutProps {
  /**
   * Route configuration (for metadata like title)
   */
  route?: RouteConfig;

  /**
   * Optional children to render instead of Outlet
   */
  children?: ReactNode;
}

/**
 * Public layout — rendered for login, errors, no auth required.
 * Supports selectively rendering the shared application footer.
 */
export const PublicLayout: React.FC<PublicLayoutProps> = ({ route, children }) => {
  return (
    <div className={styles.publicLayout}>
      {children ?? <Outlet />}
      {route?.data?.showAppFooter && (
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      )}
    </div>
  );
};

export default PublicLayout;
